export const RENTAL_AREAS = [
  "Транспорт — легкові авто",
  "Транспорт — спеціалізовані авто",
  "Спецтехніка",
  "Двоколісний транспорт",
  "Водний транспорт",
  "Повітряний транспорт",
  "Нерухомість (подобово/короткостроково)",
  "Заходи та івенти (меблі/сцена/декор/техніка)",
  "Техніка (побутова / AV)",
  "Інструменти та будівництво",
  "Інше",
];

const SECTIONS_BY_AREA = {
  // Транспорт — легкові авто
  "Транспорт — легкові авто": [
    "Економ (місто)",
    "Комфорт / Бізнес",
    "Преміум / VIP",
    "Весільні авто (з водієм)",
  ],

  // Транспорт — спеціалізовані авто
  "Транспорт — спеціалізовані авто": [
    "Кросовери / Позашляховики",
    "Мінівени / Мікроавтобуси",
    "Вантажні (фургони/пікапи/малотоннажні)",
  ],

  // Спецтехніка
  "Спецтехніка": [
    "Екскаватори / Навантажувачі",
    "Автокрани / Маніпулятори",
    "Трактори / Комбайни",
    "Дорожня техніка (катки/укладчики)",
  ],

  // Двоколісний транспорт (додано контент з «Туризму»)
  "Двоколісний транспорт": [
    "Мотоцикли",
    "Скутери / Мопеди",
    "Велосипеди (міські/MTB/електро)",
    "Електросамокати",
    "Гіроборди / Сегвеї",
    "Квадроцикли / Багі",
    "Лижі / Сноуборди / Ковзани",
    "Намети / Спальні мішки / Каремати",
  ],

  // Водний / Повітряний транспорт
  "Водний транспорт": [
    "Човни / Катамарани",
    "Катери / Яхти",
    "Гідроцикли",
    "SUP-дошки",
  ],
  "Повітряний транспорт": [
    "Вертольоти",
    "Малі літаки",
    "Повітряні кулі",
    "Дрони (для зйомок)",
  ],

  // Нерухомість
  "Нерухомість (подобово/короткостроково)": [
    "Квартири подобово",
    "Будинки / Котеджі",
    "Дачі / Заміські комплекси",
    "Офіси / Коворкінги",
    "Склади / Гаражі",
  ],

  // Івенти
  "Заходи та івенти (меблі/сцена/декор/техніка)": [
    "Меблі (столи/стільці/комплекти)",
    "Тенти / Шатра / Павільйони / Сцени",
    "Освітлення / Звук / Мікрофони",
    "Проектори / Екрани / Телевізори",
    "Декор / Фотозони",
    "Розважальне обладнання (батут/VR/ігрові)",
  ],

  // Техніка
  "Техніка (побутова / AV)": [
    "Побутова (пральні/холодильники/пилососи/кавоварки/мікрохвильовки/обігрівачі/кондиціонери)",
    "Аудіо/Відео (ТВ/проектори/екрани/акустика/мікрофони/світло)",
  ],

  // Інструменти та будівництво (додано «сад/двір»)
  "Інструменти та будівництво": [
    "Перфоратори / Дрилі",
    "Болгарки / Пили",
    "Відбійні молотки",
    "Генератори / Компресори",
    "Риштування / Драбини / Подовжувачі",
    "Садова техніка (газонокосарки/тримери/кущорізи/аератори)",
    "Мотоблоки / Культиватори",
  ],

  // Інше
  "Інше": [
    "Сейфи / Банківські комірки",
    "Касові апарати / Термінали",
    "Інше обладнання",
  ],
};

const SUBCATS_BY_SECTION = {
  // Легкові авто
  "Економ (місто)": [],
  "Комфорт / Бізнес": [],
  "Преміум / VIP": [],
  "Весільні авто (з водієм)": [],

  // Спецавто
  "Кросовери / Позашляховики": [],
  "Мінівени / Мікроавтобуси": [],
  "Вантажні (фургони/пікапи/малотоннажні)": [],

  // Спецтехніка
  "Екскаватори / Навантажувачі": [],
  "Автокрани / Маніпулятори": [],
  "Трактори / Комбайни": [],
  "Дорожня техніка (катки/укладчики)": [],

  // Двоколісний (розширений)
  "Мотоцикли": [],
  "Скутери / Мопеди": [],
  "Велосипеди (міські/MTB/електро)": [],
  "Електросамокати": [],
  "Гіроборди / Сегвеї": [],
  "Квадроцикли / Багі": [],
  "Лижі / Сноуборди / Ковзани": [],
  "Намети / Спальні мішки / Каремати": [],

  // Вода
  "Човни / Катамарани": [],
  "Катери / Яхти": [],
  "Гідроцикли": [],
  "SUP-дошки": [],

  // Повітря
  "Вертольоти": [],
  "Малі літаки": [],
  "Повітряні кулі": [],
  "Дрони (для зйомок)": [],

  // Нерухомість
  "Квартири подобово": [],
  "Будинки / Котеджі": [],
  "Дачі / Заміські комплекси": [],
  "Офіси / Коворкінги": [],
  "Склади / Гаражі": [],

  // Івенти
  "Меблі (столи/стільці/комплекти)": [],
  "Тенти / Шатра / Павільйони / Сцени": [],
  "Освітлення / Звук / Мікрофони": [],
  "Проектори / Екрани / Телевізори": [],
  "Декор / Фотозони": [],
  "Розважальне обладнання (батут/VR/ігрові)": [],

  // Техніка
  "Побутова (пральні/холодильники/пилососи/кавоварки/мікрохвильовки/обігрівачі/кондиціонери)": [],
  "Аудіо/Відео (ТВ/проектори/екрани/акустика/мікрофони/світло)": [],

  // Інструменти та будівництво (з урахуванням «сад/двір»)
  "Перфоратори / Дрилі": [],
  "Болгарки / Пили": [],
  "Відбійні молотки": [],
  "Генератори / Компресори": [],
  "Риштування / Драбини / Подовжувачі": [],
  "Садова техніка (газонокосарки/тримери/кущорізи/аератори)": [],
  "Мотоблоки / Культиватори": [],

  // Інше
  "Сейфи / Банківські комірки": [],
  "Касові апарати / Термінали": [],
  "Інше обладнання": [],
};

export const rentalFields = (attrs) => {
  const a = attrs || {};
  const area = a.area || "";
  const section = a.section || "";

  const areaOnly = [
    {
      name: "area",
      label: "Сфера *",
      type: "select",
      options: RENTAL_AREAS,
      required: true,
    },
  ];
  if (!area) return areaOnly;

  const sectionOnly = [
    ...areaOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: SECTIONS_BY_AREA[area] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const subcats = SUBCATS_BY_SECTION[section] || [];
  if (!subcats.length) return sectionOnly;

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
  ];
};
